import {Box} from 'platform/foundation';
import {css} from 'styled-components';

interface FastTrackTableCellProps {
  children: React.ReactNode;
}

const wrappingStyles = css`
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export function FastTrackTableCell(props: FastTrackTableCellProps) {
  return (
    <Box paddingLeft={4} paddingTop={3} paddingBottom={3}>
      <div css={wrappingStyles}>{props.children}</div>
    </Box>
  );
}
